(() => {
  const SIZE_GROUPS = {
    S: ['30', '32', 'S', 'Small'],
    'S/M': ['S/M', 'Small/Medium'],
    M: ['34', 'M', 'Medium'],
    L: ['L', 'Large'],
    'L/XL': ['L/XL', 'Large/XLarge'],
    XL: [
      'Extra Large',
      'XL',
      'Xlarge',
      'XLarge',
      'Xtra Large'
    ],
    XXL: [
      '36',
      'Extra Extra Large',
      'XX Large',
      'XXL',
      'XXLarge'
    ],
    'One Size': ['One Size'],
    U: ['U']
  };

  const normalize = (value) =>
    String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const getSelectedSizeGroups = () => {
    const mainForm = document.querySelector(
      'facet-filters-form #FacetFiltersForm'
    );

    if (!mainForm) return [];

    return Array.from(
      mainForm.querySelectorAll(
        'input[type="checkbox"][name="filter.v.option.size"]:checked'
      )
    )
      .map((checkbox) => {
        const label = document.querySelector(
          `label[for="${checkbox.id}"]`
        );

        if (!label) return '';

        return Array.from(label.childNodes)
          .filter(
            (node) =>
              node.nodeType === Node.TEXT_NODE
          )
          .map((node) => node.textContent)
          .join(' ')
          .trim();
      })
      .filter(Boolean);
  };

  const getFieldsetValue = (fieldset) => {
    const select =
      fieldset.querySelector('select');

    if (select) {
      return select.value;
    }

    const checked =
      fieldset.querySelector('input:checked');

    return checked ? checked.value : '';
  };

  const setFieldsetValue = (
    fieldset,
    value
  ) => {
    const select =
      fieldset.querySelector('select');

    if (select) {
      select.value = value;

      return select;
    }

    const radios = Array.from(
      fieldset.querySelectorAll(
        'input[type="radio"]'
      )
    );

    const match = radios.find(
      (radio) => radio.value === value
    );

    if (!match) return null;

    match.checked = true;

    return match;
  };

  const applySelectedCollectionSize = () => {
    const selectedGroups =
      getSelectedSizeGroups();

    /*
     * Quick View can initialize to only one
     * collection-selected size.
     */
    if (selectedGroups.length !== 1) {
      return;
    }

    const selectedGroup =
      selectedGroups[0];

    const drawer =
      document.getElementById(
        'Product-Drawer'
      );

    if (!drawer) return;

    const variantSelects =
      drawer.querySelector(
        'variant-selects'
      );

    if (!variantSelects) return;

    const fieldsets = Array.from(
      variantSelects.querySelectorAll(
        'fieldset'
      )
    );

    const sizeFieldset =
      fieldsets.find((fieldset) => {
        return (
          normalize(
            fieldset.dataset.handle
          ) === 'size'
        );
      });

    if (!sizeFieldset) return;

    const sizeOptionIndex =
      Number(
        String(
          sizeFieldset.dataset.index || ''
        ).replace('option', '')
      ) - 1;

    if (sizeOptionIndex < 0) {
      return;
    }

    const rawSizes = new Set(
      (
        SIZE_GROUPS[selectedGroup] ||
        [selectedGroup]
      ).map(normalize)
    );

    const variantJson =
      variantSelects.querySelector(
        'script[type="application/json"]'
      );

    if (!variantJson) return;

    let variants = [];

    try {
      variants = JSON.parse(
        variantJson.textContent
      );
    } catch (error) {
      console.error(
        'Could not read Quick View variant data:',
        error
      );

      return;
    }

    /*
     * Only consider actual purchasable
     * variants matching the collection size.
     */
    const availableSizeVariants =
      variants.filter((variant) => {
        if (!variant.available) {
          return false;
        }

        const variantSize =
          normalize(
            variant.options[
              sizeOptionIndex
            ]
          );

        return rawSizes.has(
          variantSize
        );
      });

    if (
      availableSizeVariants.length === 0
    ) {
      return;
    }

    const currentValues =
      fieldsets.map(getFieldsetValue);

    /*
     * Pick an available variant matching
     * the selected Size while preserving
     * the currently selected Color/etc.
     * when possible.
     */
    const chosenVariant =
      availableSizeVariants
        .map((variant) => {
          const score =
            variant.options.reduce(
              (
                total,
                option,
                index
              ) => {
                if (
                  index ===
                  sizeOptionIndex
                ) {
                  return total;
                }

                return (
                  total +
                  (
                    option ===
                    currentValues[index]
                      ? 1
                      : 0
                  )
                );
              },
              0
            );

          return {
            variant,
            score
          };
        })
        .sort(
          (a, b) =>
            b.score - a.score
        )[0].variant;

    let changeTarget = null;

    fieldsets.forEach(
      (fieldset, index) => {
        const target =
          setFieldsetValue(
            fieldset,
            chosenVariant.options[
              index
            ]
          );

        if (
          fieldset === sizeFieldset
        ) {
          changeTarget = target;
        }
      }
    );

    /*
     * Trigger Reformation's normal
     * availability recalculation.
     */
    if (changeTarget) {
      changeTarget.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );
    }
  };

  /*
   * Quick View content is injected
   * dynamically. Give Reformation a moment
   * to finish rendering before applying
   * the collection-selected Size.
   */
  document.addEventListener(
    'quick-view:open',
    () => {
      requestAnimationFrame(() => {
        setTimeout(
          applySelectedCollectionSize,
          0
        );
      });
    }
  );
})();